import { TableProps, Button } from '@insight-health-ai/roseate/components';
import { Call } from 'src/models';
import { format } from 'date-fns';
import { Tag, Typography, Tooltip } from 'antd';
import { FolderViewOutlined } from '@ant-design/icons';
import { UseGetCallListParams } from 'src/hooks/call';

const { Text } = Typography;

export const getColumns = ({
  filters,
  onPreview,
}: {
  filters: UseGetCallListParams;
  onPreview: (record: Call) => void;
}) => {
  return [
    {
      title: 'Caller',
      dataIndex: 'source',
      key: 'source',
      render: (source: string) => <Text>{source || 'N/A'}</Text>,
    },
    {
      title: 'Time',
      key: 'start_time',
      render: (_: any, record: Call) => {
        let durationStr = null;
        if (typeof record.duration === 'number' && record.duration > 0) {
          const mins = Math.floor(record.duration / 60);
          const secs = record.duration % 60;
          durationStr = `${mins}min ${secs}s`;
        }

        return (
          <div>
            <span>
              {record.start_time
                ? format(new Date(record.start_time), 'MMMM do, yyyy hh:mm a')
                : 'N/A'}
            </span>
            {durationStr && (
              <>
                <br />
                <span className="text-gray-500 text-sm">{durationStr}</span>
              </>
            )}
          </div>
        );
      },
    },

    {
      title: 'Agent',
      dataIndex: 'agent',
      key: 'agent',
      render: (agent: Call['agent']) => {
        return <Text>{agent?.name} </Text>;
      },
    },
    {
      title: 'Priority',
      dataIndex: 'priority',
      key: 'priority',
      width: 100,
      render: (priority: string) => (
        <Tag
          color={
            priority === 'high'
              ? 'red'
              : priority === 'medium'
                ? 'orange'
                : priority === 'low'
                  ? 'blue'
                  : 'default'
          }
        >
          {priority?.toUpperCase() || 'N/A'}
        </Tag>
      ),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      width: 100,
      render: (status: string) => {
        let color = 'default';
        if (status === 'ended' || status === 'completed') {
          color = 'green';
        } else if (status === 'failed') {
          color = 'red';
        } else if (status === 'in_progress' || status === 'active') {
          color = 'blue';
        }
        return <Tag color={color}>{status.toUpperCase()}</Tag>;
      },
    },

    {
      title: 'Actions',
      key: 'actions',
      width: 120,
      render: (_: any, record: Call) => (
        <Tooltip title="Preview" placement="left">
          <Button
            size="lg"
            appearance="secondary"
            variant="text"
            onClick={() => {
              onPreview(record);
            }}
            icon={<FolderViewOutlined />}
          />
        </Tooltip>
      ),
    },
  ].map((column) => {
    if (column.key === filters.sortBy) {
      return {
        ...column,
        defaultSortOrder:
          filters.sortDirection === 'desc' ? 'descend' : 'ascend',
      };
    }

    return column;
  }) as TableProps<Call>['columns'];
};
